export var SET_IM_SESSION = "IM/SET_IM_SESSION";
export var CLOSE_CHAT_BOX = "IM/CLOSE_CHAT_BOX";